
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"d":"M17 13a6 6 0 11-6-6v6h6z","stroke":"#BABABA","stroke-width":"2","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14 5a5 5 0 015 5h-5V5z","stroke":"#BABABA","stroke-width":"2","stroke-linejoin":"round"}})])
          )
        }
      }
    